import { forwardRef, InputHTMLAttributes, ReactNode, VFC } from 'react'
import { _profilegreen } from 'src/styles/colors'
import styled, { css } from 'styled-components'

type RadioButtonProps = {
  children: ReactNode
  className?: string
  value: string
  groupId?: string
} & InputHTMLAttributes<HTMLInputElement>

const id = (value: string, groupId?: string) =>
  groupId ? `${groupId}_${value}` : value

const RadioButtonComponent = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ children, className, value, groupId, ...props }, ref) => (
    <div className={className}>
      <input
        ref={ref}
        id={id(value, groupId)}
        value={value}
        type="radio"
        {...props}
        hidden
      />
      <label htmlFor={id(value, groupId)}>{children}</label>
    </div>
  ),
)

export const RadioButton = styled(RadioButtonComponent)`
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
  }
  label {
    display: block;
  }
`

export const checkedSelector = 'input[type="radio"]:checked + label'

type SimpleRadioButtonProps = {
  id: string
  name: string
  onChange: () => void
  checked: boolean
  label: string
  color?: string
}
export const SimpleRadioButton: VFC<SimpleRadioButtonProps> = ({
  id,
  name,
  onChange,
  checked,
  label,
  color = _profilegreen,
}) => {
  return (
    <SimpleRadioButtonDiv color={color}>
      <input
        id={id}
        name={name}
        type="radio"
        onChange={onChange}
        checked={checked}
      />
      <label htmlFor={id}>{label}</label>
    </SimpleRadioButtonDiv>
  )
}

export const SimpleRadioButtonDiv = styled.div<{ color?: string }>`
  input[type='radio'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
    position: relative;
    right: 0;
    bottom: 0;
    left: 0;
    transition: all 0.15s ease-out 0s;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    outline: none;
    border-radius: 10%;
  }
  input[type='radio'] {
    border-radius: 50%;
    border: 2px solid #bebebe;
  }
  input[type='radio']:checked:before {
    transform: scale(1);
  }
  input[type='radio']:before {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 3px;
    transform: scale(0);
    transition: all ease-out 250ms;
  }
  ${({ color = _profilegreen }) =>
    css`
      input[type='radio']:checked {
        border: 2px solid ${color};
      }
      input[type='radio']:checked:before {
        background: ${color};
      }
    `}
  label {
    padding-left: 8px;
  }
`
